import type { ComponentProps, MouseEvent, ReactElement } from 'react';
import type React from 'react';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import type { Button } from '../Button';

import { StyledExternalLinkButton } from './styles';

interface IProps extends Omit<ComponentProps<typeof Button>, 'children'> {
  link?: string;
  children: React.ReactNode;
}

export const ExternalLinkButton = ({ children, link, onClick, ...props }: IProps): ReactElement => {
  const handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);

    if (link) {
      window.open(link, '_blank');
    }
  };

  return (
    <StyledExternalLinkButton variant="flat" {...props} onClick={handleButtonClick}>
      {children}
      <SWReactIcons iconName="arrow-right" size="xs" iconColor={colorsPalettes.blue[500]} />
    </StyledExternalLinkButton>
  );
};
